import { render } from "./newsModal.vue?vue&type=template&id=deee3ac0&ts=true"
import script from "./newsModal.vue?vue&type=script&lang=ts"
export * from "./newsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__